import React from 'react'

import './ShowError.css'

export default props => {
    return (
        <>
            {
                !props.error ? '' : 
                <label className='labelError'>Erro ao consultar cidade!</label>
            }
            
        </>
    )
}